import { BreedingServiceLogo } from './breeding-service-logo';

export * from './breeding-service-logo-props';

export default BreedingServiceLogo;
